module.exports = __webpack_public_path__ + "static/media/music-tune-slash.3e29de5d.svg";